<script>
import store from '../../store';
import alert from '@/components/alert';
import sidebar from './sidebar';
// const sidebar = () => import('./sidebar');
export default {
    data() {
        return {
            load: !window.__PRERENDER_INJECTED,
            status: false
        }
    },
    computed: {
        spec() {
            return store.form.spec;
        }
    },
    components: {
        sidebar,
        alert
    },
    methods: {
        sidebarHandler() {
            this.status = true;
        }
    }
}
</script>

<template>
    <div class="select-spec">
        <h4 @click="sidebarHandler">{{spec.name}}</h4>
        <sidebar v-if="load" :status="status" @update:status="status = $event"></sidebar>
    </div>
</template>

<style lang="stylus" scoped>
.select-spec
    margin 0.1rem auto
    display flex
    flex-direction column
    justify-content center
    align-items center
    height 2.246rem
    max-width 14rem
    text-align center
    font-size 0
    overflow hidden
    cursor pointer
.select-spec h4
    display inline-block
    padding-right 0.78rem
    line-height 1.2
    font-weight normal
    font-size 0.746rem
    word-break keep-all
    background-image url('../../../assets/arrow-right.png')
    background-repeat no-repeat
    background-position center right
    background-size 0.426rem
    color #333
</style>